import React from "react";
import PropTypes from "prop-types";

function EstablishmentContactButton(props) {
    const { establishment, isShowroom, isWorkplace, isSchadeherstel, baseUrl } =
        props;

    let title = ss.i18n._t("EstablishmentApp.MAKE_APPOINTMENT");
    let url = baseUrl;

    if (isWorkplace) {
        title = ss.i18n._t("EstablishmentApp.MAKE_WORKPLACE_APPOINTMENT");
    } else if (isShowroom) {
        // Showroom
        // URL formatting: https://nobears.atlassian.net/browse/VMOS-3386?focusedCommentId=78210

        // Default values
        let type = "Afspraak";
        let betreft = "Sales";
        let divisie = "Autobedrijven";
        let vestiging = establishment.id;
        title = ss.i18n._t("EstablishmentApp.MAKE_APPOINTMENT");

        // Overwrites
        if (establishment.isDealer) {
            // Disabled 3/11/2021
            // ... because of lockdown  https://nobears.atlassian.net/browse/VMOS-3386?focusedCommentId=79265
            // title = ss.i18n._t('EstablishmentApp.MAKE_SHOWROOM_APPOINTMENT');
        } else if (establishment.isLeaser) {
            divisie = "Leasebedrijven";
        } else if (establishment.isDamageRestorer) {
            divisie = "Schadebedrijven";
            betreft = "Aftersales";
        }

        url = `${baseUrl}?s=${type}&b=${betreft}&d=${divisie}&v=${vestiging}`;
    }

    return (
        <a href={url} className="button-arrow">
            {title}
        </a>
    );
}

EstablishmentContactButton.propTypes = {
    establishment: PropTypes.shape({
        id: PropTypes.number,
        isDamageRestorer: PropTypes.number,
        isDealer: PropTypes.number,
        isLeaser: PropTypes.number,
    }).isRequired,
    isShowroom: PropTypes.bool,
    isWorkplace: PropTypes.bool,
    isSchadeherstel: PropTypes.bool,
    baseUrl: PropTypes.string,
};

EstablishmentContactButton.defaultProps = {
    isShowroom: false,
    isWorkplace: false,
    isSchadeherstel: false,
    baseUrl: "/",
};

export default EstablishmentContactButton;
